import React, {Component} from 'react';
import {closeInfoModal} from "./EditInfoActions";
import Modal from "../../../../components/material-pro/Modal/Modal";
import {connect} from "react-redux";
import withStyles from "@material-ui/core/es/styles/withStyles";


const styles = theme => ({
    big: {
      maxHeight: 435,
    },
  });

class EditInfo extends Component {

    render() {
        const {classes, handleCardErrors, error, infoModal:{open, content, text}, closeInfoModal } = this.props;
        return (
                <Modal open={open} medium={true} onClose={closeInfoModal} content={content} title={text}/>   
        );
    }
}

const mapStateToProps = ({infoModal, billing}) => ({infoModal, billing});

export default connect(mapStateToProps, {closeInfoModal})(withStyles(styles)(EditInfo));


// WEBPACK FOOTER //
// ./src/containers/billing/components/edit-info/EditInfo.js